import { AppState } from '../../helpers/store/AppState';

export const selectToastState = (state: AppState) => state.toast;
